import React, { Component } from 'react';
import Highlighter from 'react-highlight-words';
import Utility from '../../../Utility';
import { connect } from 'react-redux';
import FeaturePaneHeading from './FeaturePaneHeading';

import './TranscriptViewer.css';

// const _ = require('lodash');

// import { ReactComponent as IconDownload } from './TranscriptIcons/download.svg';


class TranscriptViewer extends Component {
	constructor(props) {
		super(props);

		this.transScroll = React.createRef();

		this.state = {
			captions: this.props.data.recording.info.captions,
			currentCaption: 0,
			searchText: '',
			searchWords: [],
			autoFollow: true
		}

		for (var i = this.state.captions.length - 1; i >= 0; i--) {
			this.state.captions[i].text = this.state.captions[i].text.replace('<br />', "\n");
			this.state.captions[i].originalIndex = i;
			this.state.captions[i].searchIndex =  this.state.captions[i].text.toLowerCase();
		}

		this.ignoreScrollEvent = false;
	}

	findByTime = () => {
		var i = 0,
			j = -1;

		while (i < this.state.captions.length) {
			var inTime = this.state.captions[i].intime;

			if (this.props.dynamic.currentTime < inTime) {
				break;
			}

			i++;
			j++;
		}

		if (j === -1) { j = 0; }

		if (this.state.currentCaption !== j) {
			this.setState({ currentCaption: j });
		}
	}

	componentDidUpdate(prevProps) {
		this.findByTime();

		if (this.state.autoFollow === true) {
			var line = document.getElementById(this.state.currentCaption + '-transcript-line');
			if (line) {
				this.ignoreScrollEvent = true;
				this.transScroll.current.scrollTop = line.offsetTop - (this.transScroll.current.offsetHeight/2);
			}
		}
	}

	onchangeHandler = (ev) => {
		let searchWords = ev.target.value.trim();

		if (searchWords === '') {
			searchWords = [];
		} else {
			searchWords = searchWords.split(' ').map((word) => {
				return word.toLowerCase();
			});
		}

		this.setState({
			autoFollow: ev.target.value === '',
			searchText: ev.target.value,
			searchWords: searchWords
		});
	}

	onscrollHandler = (ev) => {
		if (this.ignoreScrollEvent) {
			this.ignoreScrollEvent = false;
			return;
		}

		if (this.state.autoFollow === true) {
			this.setState({
				autoFollow: false
			});
		}
	}

	autoScrollClickHandler = (ev) => {
		this.setState({
			autoFollow: true
		});
	}

	render() {
		let visibleCaptions = this.state.captions.filter((caption) => {
			if (this.state.searchWords.length > 0) {
				for (var i = this.state.searchWords.length - 1; i >= 0; i--) {
					if (!caption.searchIndex.includes(this.state.searchWords[i])) {
						return false;
					}
				}
			}

			return true;
		});

		let transcriptViewerClass = 'transcript-viewer';

		if (this.state.searchWords.length > 0) {
			transcriptViewerClass += ' results';
		}

		let resultsSuffix = '';

		if (visibleCaptions.length !== 1) {
			resultsSuffix += 's';
		}

		return (
			<div className={transcriptViewerClass}>
				<FeaturePaneHeading title="Transcript" closeLabel="Close transcript" onClose={() => this.props.updatePlayerState({ transcript: false })} />
				<div className="toolbar" role="search">
					<input autoFocus autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck={false} writingsuggestions="false" aria-label="Search transcript" id="search_transcript" type="search" placeholder="Search transcript" value={this.state.searchText} onChange={this.onchangeHandler} />
					{ this.state.autoFollow ? null : <button className="text-button" onClick={this.autoScrollClickHandler}>Auto scroll</button> }
					{/*<button><IconDownload /></button>*/}
				</div>
				{ this.state.searchWords.length > 0 ?
					<div className="search-results-summary" aria-live="polite">
						Found <strong>{visibleCaptions.length}</strong> result{resultsSuffix}
					</div> : null
				}
				<div role="list" ref={this.transScroll} className="transcript-scroller" onScroll={this.onscrollHandler}>
					{ visibleCaptions.length === 0 ? <div className="no-search-results"><p>No caption lines matched your search.</p></div> : null }
					{ visibleCaptions.map((caption, index) => {
						return <TranscriptRow searchWords={this.state.searchWords} trigger={this.props.trigger} active={caption.originalIndex === this.state.currentCaption} key={index} caption={caption} />
					})}
				</div>
			</div>
		);
	}
}

class TranscriptRow extends React.PureComponent {
	jumpToCaption = (ev) => {
		this.props.trigger('seekonly', this.props.caption.intime);
	}

	transcriptlineKeydown = (ev) => {
		switch (ev.key) {
			case 'Enter':
				this.props.trigger('seekonly', this.props.caption.intime);
				ev.stopPropagation();
				break;
			default:
				// do nothing
		}
	}

	render() {
		var rowClass = 'transcript-row';

		if (this.props.active) {
			rowClass += ' active';
		}

		return (
			<div className={rowClass} role="listitem" id={this.props.caption.originalIndex + '-transcript-line'} onClick={this.jumpToCaption} tabIndex="0" onKeyDown={this.transcriptlineKeydown}>
				<div className="transcript-time">{Utility.sec2hms(this.props.caption.intime)}</div>
				<div className="transcript-text">
					<Highlighter
						highlightClassName="highlighted"
						searchWords={this.props.searchWords}
						autoEscape={true}
						textToHighlight={this.props.caption.text}
					/>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	dynamic: state.dynamic,
});

export default connect(mapStateToProps)(TranscriptViewer);
